// extracted by mini-css-extract-plugin
export var box = "_5i-1";
export var checked = "_5i-2";
export var descriptionSpacer = "_5i-9";
export var disabled = "_5i-3";
export var icon = "_5i-6";
export var input = "_5i-0";
export var labelSpacer = "_5i-8";
export var medium = "_5i-5";
export var small = "_5i-4";
export var text = "_5i-7";